import useSWR from 'swr';
import { fetchApiHub } from '../../lib/fetch-api-hub';
import { ShopCountries } from '@Types/config/Country';

export const useCountries = (): ShopCountries => {
  const { data } = useSWR('/action/config/getCountries', {
    fetcher: fetchApiHub,
    fallbackData: {},
  });

  return data;
};
